export default {
  title: 'Commissioni',
  subtitle: 'Override commissione di servizio per ristorante per {{company}}.',
  card_title: 'Commissione di servizio',
  banner: {
    default_summary: 'Default partner: {{percentage}}% · min {{min}} · max {{max}}.',
    override_hint: 'Imposta sotto un importo diverso per questo ristorante.',
    suggested_summary: 'Valori iniziali suggeriti: {{percentage}}% · min {{min}} · max {{max}}.',
    suggested_hint: 'Modificali qui sotto e salva per applicare una commissione di servizio in questo ristorante.',
    own_fee_hint: 'Questo ristorante applica una propria commissione, impostata qui sotto.',
    saved_summary: 'Ultimi valori salvati: {{percentage}}% · min {{min}} · max {{max}}.',
    saved_hint: 'La commissione di servizio è disattivata. Salva questi valori, o modificali prima, per riattivarla.',
  },
  form: {
    recommended: 'Consigliato: {{value}}',
    percentage: {
      label: 'Percentuale commissione di servizio',
      tooltip: "Percentuale del valore dell'ordine addebitata al cliente come commissione di servizio.",
    },
    min_amount: {
      label: 'Commissione di servizio minima',
      tooltip: 'Le commissioni calcolate al di sotto di questo importo vengono arrotondate ad esso.',
    },
    max_amount: {
      label: 'Commissione di servizio massima',
      tooltip: "La commissione di servizio non supera mai questo importo, indipendentemente dal valore dell'ordine.",
    },
  },
  limits:
    'Deve rientrare nei limiti FoodAmigos: max {{max_percentage}}% / {{max_amount}}, minimo almeno {{min_amount}}.',
  not_charged_notice:
    'Al momento in questo ristorante non viene applicata alcuna commissione di servizio. Salva una commissione qui sotto per attivarla.',
  zero_percentage_warning:
    'Una percentuale dello 0% non disabilita la commissione: le commissioni calcolate al di sotto del minimo vengono arrotondate ad esso, quindi ogni ordine viene comunque addebitato almeno del minimo.',
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
    reset_to_default: 'Ripristina default partner',
    turn_off: 'Disattiva commissione di servizio',
  },
  toasts: {
    load_error: 'Impossibile caricare le impostazioni della commissione di servizio.',
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
    reset_to_default: 'Override rimosso — viene applicato il default del partner.',
    reset_to_default_skipped:
      'Override rimosso — nessuna commissione di servizio verrà addebitata finché non ne salvi una.',
    turned_off: 'Commissione di servizio disattivata. I tuoi valori vengono conservati per quando la riattiverai.',
  },
};
